export const SOFTWARE_ACCESS = {
  IMS: 1,
  DMS: 2,
  RMS: 3,
};

export const PRODUCTION_PLANNING_STATUS = {
  YET_TO_START: 1,
  PRODUCTION_STARTED: 2,
  PRODUCTION_COMPLETED: 3,
};

export const USER_ROLES = {
  ADMIN: 1,
  ACCOUNT: 2,
  PURCHASE: 3,
  DESIGN_TEAM: 4,
  PRODUCTION: 5,
  PACKAGING_AND_DISPATCH: 6,

  ASSEMBLY: 7,
  QC_PACAKAGING: 8,
  QC_UAE: 9,

  HR: 10,
  INVENTORY: 11,
  ELECTRONIC: 12,
  REGULATORY: 13,
};

export const actions = {
  SIGN_IN: "SIGN_IN",
  SET_USER: "SET_USER",
  SIGN_OUT: "SIGN_OUT",
  OPEN_MODAL: "OPEN_MODAL",
  CLOSE_MODAL: "CLOSE_MODAL",
  UPDATE_USER_DATA: "UPDATE_USER_DATA",
  SET_USER_LAST_READ_NOTIFICATION: "SET_USER_LAST_READ_NOTIFICATION",
  CALL_SNACKBAR_DATA: "CALL_SNACKBAR_DATA",
  SET_NOTIFICATION_DATA: "SET_NOTIFICATION_DATA",
  NOTIFICATION_READ: "NOTIFICATION_READ",

  FETCH_DATA_VENDER_LODING: "FETCH_DATA_VENDER_LODING",
  FETCH_DATA_VENDER_DATA: "FETCH_DATA_VENDER_DATA",
  FETCH_DATA_VENDER_DELETE: "FETCH_DATA_VENDER_DELETE",

  FETCH_DATA_RAWMATERIAL_LODING: "FETCH_DATA_RAWMATERIAL_LODING",
  FETCH_DATA_RAWMATERIAL_DATA: "FETCH_DATA_RAWMATERIAL_DATA",
  FETCH_DATA_RAWMATERIAL_DELETE: "FETCH_DATA_RAWMATERIAL_DELETE",

  FETCH_DATA_PRODUCT_LODING: "FETCH_DATA_PRODUCT_LODING",
  FETCH_DATA_PRODUCT_DATA: "FETCH_DATA_PRODUCT_DATA",
  FETCH_DATA_PRODUCT_DELETE: "FETCH_DATA_PRODUCT_DELETE",

  FETCH_DATA_DEPARTMENT_LODING: "FETCH_DATA_DEPARTMENT_LODING",
  FETCH_DATA_DEPARTMENT_DATA: "FETCH_DATA_DEPARTMENT_DATA",
  FETCH_DATA_DEPARTMENT_DELETE: "FETCH_DATA_DEPARTMENT_DELETE",

  FETCH_DATA_TYPE_OF_SALES_LODING: "FETCH_DATA_TYPE_OF_SALES_LODING",
  FETCH_DATA_TYPE_OF_SALES_DATA: "FETCH_DATA_TYPE_OF_SALES_DATA",
  FETCH_DATA_TYPE_OF_SALES_DELETE: "FETCH_DATA_TYPE_OF_SALES_DELETE",

  FETCH_DATA_CATEGORY_LODING: "FETCH_DATA_CATEGORY_LODING",
  FETCH_DATA_CATEGORY_DATA: "FETCH_DATA_CATEGORY_DATA",
  FETCH_DATA_CATEGORY_DELETE: "FETCH_DATA_CATEGORY_DELETE",

  FETCH_DATA_PRODUCT_SUB_CATEGORY_LODING:
    "FETCH_DATA_PRODUCT_SUB_CATEGORY_LODING",
  FETCH_DATA_PRODUCT_SUB_CATEGORY_DATA: "FETCH_DATA_PRODUCT_SUB_CATEGORY_DATA",
  FETCH_DATA_PRODUCT_SUB_CATEGORY_DELETE:
    "FETCH_DATA_PRODUCT_SUB_CATEGORY_DELETE",

  FETCH_DATA_UPDATE_STOCK_PRODUCT_LODING:
    "FETCH_DATA_UPDATE_STOCK_PRODUCT_LODING",
  FETCH_DATA_UPDATE_STOCK_PRODUCT_DATA: "FETCH_DATA_UPDATE_STOCK_PRODUCT_DATA",
  FETCH_DATA_UPDATE_STOCK_PRODUCT_DELETE:
    "FETCH_DATA_UPDATE_STOCK_PRODUCT_DELETE",

  FETCH_DATA_UPDATE_STOCK_RAW_MATERIAL_LODING:
    "FETCH_DATA_UPDATE_STOCK_RAW_MATERIAL_LODING",
  FETCH_DATA_UPDATE_STOCK_RAW_MATERIAL_DATA:
    "FETCH_DATA_UPDATE_STOCK_RAW_MATERIAL_DATA",
  FETCH_DATA_UPDATE_STOCK_RAW_MATERIAL_DELETE:
    "FETCH_DATA_UPDATE_STOCK_RAW_MATERIAL_DELETE",

  FETCH_DATA_QUALITY_CHECK_LODING: "FETCH_DATA_QUALITY_CHECK_LODING",
  FETCH_DATA_QUALITY_CHECK_DATA: "FETCH_DATA_QUALITY_CHECK_DATA",
  FETCH_DATA_QUALITY_CHECK_DELETE: "FETCH_DATA_QUALITY_CHECK_DELETE",

  FETCH_BATCH_LODING: "FETCH_BATCH_LOADING",
  FETCH_BATCH_DATA: "FETCH_BATCH_DATA",
  FETCH_BATCH_DELETE: "FETCH_BATCH_DELETE",

  FETCH_DATA_PRODUCT_BRAND_LODING: "FETCH_DATA_PRODUCT_BRAND_LODING",
  FETCH_DATA_PRODUCT_BRAND_DATA: "FETCH_DATA_PRODUCT_BRAND_DATA",
  FETCH_DATA_PRODUCT_BRAND_DELETE: "FETCH_DATA_PRODUCT_BRAND_DELETE",

  FETCH_DATA_PRODUCT_COLOR_LODING: "FETCH_DATA_PRODUCT_COLOR_LODING",
  FETCH_DATA_PRODUCT_COLOR_DATA: "FETCH_DATA_PRODUCT_COLOR_DATA",
  FETCH_DATA_PRODUCT_COLOR_DELETE: "FETCH_DATA_PRODUCT_COLOR_DELETE",

  FETCH_DATA_PRODUCT_TYPE_LODING: "FETCH_DATA_PRODUCT_TYPE_LODING",
  FETCH_DATA_PRODUCT_TYPE_DATA: "FETCH_DATA_PRODUCT_TYPE_DATA",
  FETCH_DATA_PRODUCT_TYPE_DELETE: "FETCH_DATA_PRODUCT_TYPE_DELETE",

  FETCH_COMPONENT_LODING: "FETCH_COMPONENT_LODING",
  FETCH_COMPONENT_DATA: "FETCH_COMPONENT_DATA",
  FETCH_COMPONENT_DELETE: "FETCH_COMPONENT_DELETE",

  FETCH_ITEM_TYPE_LODING: "FETCH_ITEM_TYPE_LODING",
  FETCH_ITEM_TYPE_DATA: "FETCH_ITEM_TYPE_DATA",
  FETCH_ITEM_TYPE_DELETE: "FETCH_ITEM_TYPE_DELETE",

  FETCH_REJECTION_REASON_LODING: "FETCH_REJECTION_REASON_LODING",
  FETCH_REJECTION_REASON_DATA: "FETCH_REJECTION_REASON_DATA",
  FETCH_REJECTION_REASON_DELETE: "FETCH_REJECTION_REASON_DELETE",

  FETCH_INVENTORY_MASTER_LODING: "FETCH_INVENTORY_MASTER_LODING",
  FETCH_INVENTORY_MASTER_DATA: "FETCH_INVENTORY_MASTER_DATA",
  FETCH_INVENTORY_MASTER_DELETE: "FETCH_INVENTORY_MASTER_DELETE",

  SET_VERSION_DATA: "SET_VERSION_DATA",
  START_VERSION_LOADING: "START_VERSION_LOADING",
  SET_VERSION_DATA_ONDELETE: "SET_VERSION_DATA_ONDELETE ",
};

export const NOTIFICATION_TYPE = {
  general: "general",
  lead: "lead",
};

export const YES_NO = {
  Pass: true,
  Reject: false,
};

export const SNACK_BAR_VARIETNS = {
  error: "error",
  suceess: "success",
  info: "info",
  warning: "warning",
};

export const DAY_WEEK_MONTH = {
  DAY: "day",
  WEEK: "week",
};

export const LOG_TYPE = {
  In: 1,
  Out: -1,
};

export const DATE_TIME_FILTERS = {
  this_week: "This Week",
  this_month: "This Month",
  this_year: "This Year",
  last_month: "Last Month",
  last_year: "Last Year",
  last_week: "Last Week",
  today: "Today",
  yesterday: "Yesterday",
};

export const REQUEST_TYPE = {
  MATERIAL: 1,
  PURCHASE: 2,
};

export const MATERIAL_TYPE = {
  RAW_MATERIALS: 1,
  SKD: 2,
  SFG: 3,
  FG: 4,
  // ITEM: 5,
};

export const PRODUCTION_FG_STATUS = {
  REWORKABLE: 1,
  REJECTED: 2,
  PASSED: 3,
};
export const MATERIAL_REQUEST_STATUS = {
  PENDING: 1,
  APPROVAL_1: 2,
  ORDER_PLACED: 3,
  ALLOCATED: 4,
  REJECTED: 5,
  ORDER_RECEIVED: 6,
  DIRECT_APPROVED: 7,
  MATERIAL_RECEIVED: 8,
};

export const PRODUCTION_PURCHASE_STATUS = {
  PENDING: 1,
  ORDER_PLACED: 2,
  ORDER_RECEIVED: 3,
  REJECTED: 4,
};

export const GRN_TYPE = {
  STANDARD: 1,
  IQC_REJECTED: 2,
  RETURNED: 3,
};

export const STATUS_COLOR_TYPE = (currentstatus) => {
  switch (currentstatus) {
    case true:
      return "#255766";
    default:
      return "white";
  }
};

export const BUTTON_STATUS_COLOR_TYPE = (currentstatus) => {
  switch (currentstatus) {
    case true:
      return "contained";
    default:
      return "outlined";
  }
};

export const QC_TEST_CASE = {
  FUNCTIONALITY_TEST: 1,
  APPEARANCE_TEST: 2,
  ACCESSORIES: 3,
  DEVICE_DETAILS: 4,
  LEFT_FUNCTIONALITY_TEST: 5,
  RIGHT_FUNCTIONALITY_TEST: 6,
  LEFT_APPEARANCE_TEST: 7,
  RIGHT_APPEARANCE_TEST: 8,
  LEFT_ACCESSORIES: 9,
  RIGHT_ACCESSORIES: 10,
  LEFT_DEVICE_DETAILS: 11,
  RIGHT_DEVICE_DETAILS: 12,
};

export const QC_TEST_CASE_BAND = {
  FUNCTIONALITY_TEST: 1,
  APPEARANCE_TEST: 2,
  ACCESSORIES: 3,
};

export const QC_TEST_CASE_HEARING_AID = {
  LEFT_FUNCTIONALITY_TEST: 1,
  LEFT_APPEARANCE_TEST: 2,
  ACCESSORIES: 3,
  RIGHT_FUNCTIONALITY_TEST: 4,
  RIGHT_APPEARANCE_TEST: 5,
};
export const CATEGORY = {
  HEARING_BAND: 1,
  HEARING_AID: 2,
};

export const COUNTRY_CATEGORY = {
  GENERAL: 8,
  UAE: 9,
};
export const UNITS = {
  KG: 1,
  MTR: 2,
  NOS: 3,
  SET: 4,
  PCS: 5,
  LTR: 6,
};

export const VENDOR_PRIORITY = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
};

export const MATERIAL_STAGES = {
  AVAILABLE: 1,
  PURCHASE: 2,
  RECEIVED: 3,
  // IQC_COMPLETED: 4,
  // PRODUCTION_STARTED: 5,
  // PRODUCTION_COMPLETED: 6,
  // TESTED_AND_APPROVED: 7,
};
export const ITEM_STATUS = {
  AVAILABLE: 1,
  ASSIGNED: 2,
};
export const APP_TYPES = {
  WEB: 1,
  APP: 2,
};

export const DEVICES = {
  BTE_OPTIMA: 1,
  BTE_PRIME: 2,
  RIC_OPTIMA: 6,
  RIC_OPTIMA_8C: 8,
  ITE_OPTIMA: 9,
  // POWER_BTE: 10,
  RIC_32: 11,
  ITE_PRIME: 12,
  NECKBAND: 13,

  WEHEAR_OX: 14,
  SAFE_BUDS: 15,
  // SAFE_HEADPHONE: 16,
  WEHEAR_2_0: 17,
  RIC_OPTIMA_8: 18,
};

export const QC_BUTTON_FILTER = {
  ALL: 1,
  PASSED: 2,
  QC_PENDING: 3,
  REJECTED: 4,
};

export const CURRENCY = {
  INR: 1,
  USD: 2,
  EUR: 3,
};
